import { Component, HostBinding, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'pot-modal-layout',
  templateUrl: './pot-modal-layout.component.html',
  styleUrls: ['./pot-modal-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PotModalLayoutComponent {
  private activeModal: NgbActiveModal = inject(NgbActiveModal);

  @Input() public title: string = '';

  @HostBinding('class') public classes: string =
    'tw-relative tw-flex tw-flex-col tw-gap-1 tw-h-full tw-overflow-hidden tw-py-7';

  public close(): void {
    this.activeModal.dismiss();
  }
}
